var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 129,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m167.524 83.421-8.045 4.645 4.645 8.046 8.045-4.645-4.645-8.046ZM165.44 26.13c.07-.4.29-.77.65-1.02l3.37-2.35c.72-.5 1.7-.33 2.21.39.5.72.33 1.7-.39 2.21l-3.37 2.35c-.72.5-1.7.33-2.21-.39a1.61 1.61 0 0 1-.26-1.19ZM161.52 113.73a1.55 1.55 0 1 0 0-3.1 1.55 1.55 0 0 0 0 3.1Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.62 50.18-33.4 7.76M159.73 103.17l-25.58-8.55M147.151 12.05l-4.921 6.71",
    stroke: "#4C6EF5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 102.7c7.456 0 13.5-6.044 13.5-13.5s-6.044-13.5-13.5-13.5S0 81.744 0 89.2s6.044 13.5 13.5 13.5Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 100.95c7.456 0 13.5-6.044 13.5-13.5s-6.044-13.5-13.5-13.5S.7 79.994.7 87.45s6.044 13.5 13.5 13.5Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45 90.66a8.682 8.682 0 0 0 12.09-2.16",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.24 78.91 2.86 2.25 3.48-1.08-1.26 3.42 2.1 2.97-3.64-.14-2.18 2.92-.99-3.51-3.45-1.17 3.03-2.02.05-3.64ZM14.36 77.82l3.58-.68 1.46-3.34 1.76 3.19 3.62.36-2.49 2.66.78 3.55-3.3-1.54-3.14 1.84.45-3.62-2.72-2.42Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.28 25.25c5.53-1.09 10.9 2.5 12 8.04 1.09 5.53-2.5 10.9-8.04 12-5.53 1.09-10.9-2.5-11.99-8.04-1.1-5.53 2.49-10.9 8.03-12Z",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.11 43.64a12.352 12.352 0 0 1-3.02-5.97c-1.33-6.72 3.04-13.24 9.76-14.57s13.24 3.04 14.57 9.76c.82 4.15-.54 8.23-3.28 11.06-.45.47-.94.9-1.47 1.29M44.66 47.43a12.336 12.336 0 0 1-9.62-2.09",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 39.74c-1.73 4.85-5.9 8.7-11.32 9.77-8.2 1.62-16.15-3.71-17.78-11.91-.67-3.4-.15-6.77 1.29-9.65M31.21 24.22c2.08-2.18 4.82-3.76 8-4.38 8.2-1.62 16.16 3.71 17.78 11.91",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.74 17.37c7.47.69 13.92 6.2 15.44 13.93 1.86 9.41-4.26 18.55-13.67 20.41M26.2 41.6c-.48-1.12-.86-2.31-1.1-3.55-1.82-9.2 3.99-18.15 13.05-20.28.2-.05.41-.09.62-.13M140.13 119.349a3.32 3.32 0 0 1-3.33 3.32c-1.84 0-3.33-1.49-3.33-3.32a3.32 3.32 0 0 1 3.33-3.32 3.308 3.308 0 0 1 3.33 3.32Z",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81 125.15a5.8 5.8 0 1 0 0-11.6 5.8 5.8 0 0 0 0 11.6Z",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.68 119.35c0 4.9-3.97 8.88-8.88 8.88a8.88 8.88 0 0 1-8.88-8.88c0-4.91 3.97-8.88 8.88-8.88a8.88 8.88 0 0 1 8.88 8.88Z",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53 7.06 69.51 17.71M61.22 20.08 78.59 1.2",
    stroke: "#4C6EF5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.07 72.53-5.05 2.05-.44 9.67s7.69-1.65 7.09-4.42c-.33-1.51-3.55-2.36-1.6-7.3Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.34 71.48s-1.62.27-2.42 2.53c-.8 2.26-.14 5.82 1.3 7 1.45 1.18 3.6.51 3.6.51l-2.48-10.04Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.22 123.17c-3.19.42-13.97 1.64-21.11.04a.544.544 0 0 1-.34-.8l4.06-7.04.37-4.77 16.57 1.18 1.26 10.34c.06.51-.3.98-.81 1.05Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.52 103.159-16.94-5.43s-9.28 11.56-4.05 19.9c0 0 3.45-6.44 19.61 2.31l1.38-16.78Z",
    fill: "#748FFC",
    stroke: "#748FFC",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.15 97.06s-4.12-.03-4.58.67c-.46.7-1.16.88 5.49 3.04 5.49 1.78 10.07 1.78 10.07 1.78",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.15 97.06s-4.12-.03-4.58.67c-.46.7-1.16.88 5.49 3.04 5.49 1.78 10.07 1.78 10.07 1.78",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.74 94.15c-1.99.75-3.51 4.74-2.97 3.88 0 0 .38 1.77 4.05 1.77.92 0 1.21-.34 1.21-.34",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.84 87.6s-1.68 11.82 7.26 14.29c8.94 2.47 14.83-6.48 14.85-9.47.02-2.99-3.73-5.62-3.73-5.62l-18.38.8Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2 112.149s-4.47 3.53-4.06 6.61c.41 3.08 20.29 4.74 19.22-.82-1.07-5.56-15.16-5.79-15.16-5.79Z",
    fill: "#748FFC",
    stroke: "#748FFC",
    strokeWidth: 1.183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.84 87.56s10.5 4.43 18.39-.76l-9.27-2.23-9.12 2.99Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.81 82.79-1.63 4.01s7.07 2.21 11.451-.9v-3.48l-9.82.37Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.411 90.59c-1.64-.74-4.56-1.28-8.53.99 0 0-.92 6.52-1.83 7.38-.91.86 1.09 2.199 1.09 2.199s8.96-.7 10.58-8.02c.24-1.06-.34-2.12-1.31-2.55ZM112.49 119.69l.95 3.92s0 .92-10.07 1.83c-10.07.92-8.24-1.43-8.24-1.43l1.79-7.45s1.43-3.86 9.2-3.14c7.76.73 6.37 6.27 6.37 6.27Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.14 119.94s-1.83-3.66 5.49-5.49c6.76-1.69 13.73 5.49 13.73 5.49s1.3-15.85-5.49-22.21c-3.35-3.13-13.73 4.36-13.73 4.36s-1.83 11.45 0 17.85Z",
    fill: "#BAC8FF",
    stroke: "#BAC8FF",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87 98c-.24-.08-.48-.17-.71-.26-.9-.34-1.28-1.42-.78-2.25l.16-.27c.59-.99 1.88-1.32 2.87-.72l3.19 1.9-4.73 1.6Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.14 66.04s-9.19.97-10.6 2.65c-1.42 1.68 2.81 6.19 2.47 9.85-.34 3.66-2.78 8.39 7.32 6.03 5.62-1.32 8.641-1.21 10.211-.85.94.22 1.889-.31 2.149-1.24.87-3.16 2.461-9.27 2.471-11.96 0-3.7-8.11-4.75-8.11-4.75l-5.91.27Z",
    fill: "#748FFC",
    stroke: "#748FFC",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.76 68.69c14.409 0 26.09-11.681 26.09-26.09 0-14.41-11.681-26.09-26.09-26.09-14.41 0-26.09 11.68-26.09 26.09 0 14.409 11.68 26.09 26.09 26.09Z",
    fill: "#BAC8FF",
    stroke: "#BAC8FF",
    strokeWidth: 1.183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.22 34.88c-2.22.86-4.65 1.04-6.99.59-3.91-.74-9.16-1.35-12.31-.09-5.49 2.19-8.24 8.6-5.49 15.01s6.25 6.5 10.9 6.45c4.66-.05 8.56-3.03 14.73-2.79 6.861.27 7.951.77 13.491 0 8.59-1.19 8.96-10.98 7.8-14.64-1.16-3.66-4.82-9.15-15.8-6.41-3.06.75-5.05 1.38-6.33 1.88Z",
    fill: "#4263EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8 66.06s-8.3-1.2-10.53 1.26c-2.23 2.46-3 5.03-3 5.03s11.12 1.84 13.53-6.29Z",
    fill: "#BAC8FF",
    stroke: "#BAC8FF",
    strokeWidth: 1.175,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.49 54.04a7.32 7.32 0 1 0 0-14.64 7.32 7.32 0 0 0 0 14.64Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.49 50.39a4.58 4.58 0 1 0 0-9.16 4.58 4.58 0 0 0 0 9.16Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.13 45.54a1.37 1.37 0 1 0 0-2.74 1.37 1.37 0 0 0 0 2.74ZM107.041 51.3a7.32 7.32 0 1 0-.001-14.64 7.32 7.32 0 0 0 .001 14.64Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.04 47.64a4.58 4.58 0 1 0 0-9.16 4.58 4.58 0 0 0 0 9.16Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.681 42.79a1.37 1.37 0 1 0 0-2.741 1.37 1.37 0 0 0 0 2.74Z",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12 45.35a1.37 1.37 0 1 0 0-2.74 1.37 1.37 0 0 0 0 2.74ZM79.9 48.37a1.37 1.37 0 1 0 0-2.74 1.37 1.37 0 0 0 0 2.74Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.35 25.19s2.94 5.52 17.58 3.69c14.641-1.83 17.611-7.04 17.611-7.04",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.69 72.2c-.1.36-.16.72-.16 1.07 0 2.75 6.41 8.24 6.41 8.24s7.3 4.5 9.6 4.08c2.3-.42 5.05-1.34 5.05-1.34.92 0 1.83-1.83 1.83-5.49s-3.56-9.23-4.98-11.02c-.58-.74-2.47-1.32-4.62-1.7",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.69 72.2c-.1.36-.16.72-.16 1.07 0 2.75 6.41 8.24 6.41 8.24s7.3 4.5 9.6 4.08c2.3-.42 5.05-1.34 5.05-1.34.92 0 1.83-1.83 1.83-5.49s-3.56-9.23-4.98-11.02c-.58-.74-2.47-1.32-4.62-1.7",
    stroke: "#BAC8FF",
    strokeWidth: 1.183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.92 70.52s-1.35 8-3.66 9.15c-3.66 1.83-8.24-.92-8.24-.92M79.58 84.25l-7.33-4.58",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.97 69.6s-1.37 2.2 2.29 1.56c2.52-.44 1.57-2.31.74-3.43-.41-.55-.81-1.1-1.19-1.66-.51-.74-1.39-1.65-2.45-1.05-1.68.92 1.06 2.75.61 4.58ZM64.43 69.35c.36-.99.21-2.09-.38-2.96-1.2-1.77-3.34-4.45-4.61-3.18-1.83 1.83 2.08 3.63 1.04 5.02-1.38 1.84-2.87-4.1-2.87-.44 0 4.15 1.76 5.21 3.66 4.58 2.03-.69 2.73-1.84 3.16-3.02ZM110.041 72.4c.26-1.5-.34-3.07-1.64-3.87-.19-.12-.38-.2-.55-.25-1.06-.27-3.43.91-3.43 6.83s-1.68 8.83.93 9.15c2.12.25 3.98-7.81 4.69-11.86Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.63 73.68c-.37-1.25-1.37-2.26-2.66-2.51-.96-.19-2.03.02-2.78 1.4-1.67 3.06.36 8.27 4.16 7.73 2.73-.39 1.94-4.4 1.28-6.62Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12 65.69a6.709 6.709 0 0 0-3.23.13c-1.42.4-2.86.73-4.34.78-1.15.04-2.79.3-4.94 1.13-4.83 1.87-2.09 6.44-4.83 11.02-2.75 4.58 3.98 8.22 9.31 6.86 5.33-1.36 12.66-5.03 13.57-11.43.19-1.34.06-2.6-.31-3.72",
    fill: "#BAC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12 65.69a6.709 6.709 0 0 0-3.23.13c-1.42.4-2.86.73-4.34.78-1.15.04-2.79.3-4.94 1.13-4.83 1.87-2.09 6.44-4.83 11.02-2.75 4.58 3.98 8.22 9.31 6.86 5.33-1.36 12.66-5.03 13.57-11.43.19-1.34.06-2.6-.31-3.72",
    stroke: "#BAC8FF",
    strokeWidth: 1.183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.361 67.77s-2.75 4.26 0 10.83c2.75 6.56 18.31-4.42 18.31-4.42",
    stroke: "#4C6EF5",
    strokeWidth: 1.183,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.02 72.23c1.06-.15 1.46-1.53.7-2.28-.4-.4-.82-1.07-1.08-2.22-.62-2.71-3.36.95-2.45 2.78.55 1.11 1.76 1.88 2.83 1.72ZM125.681 68.69c-.23-1.08.23-2.18 1.15-2.79.64-.43 1.41-1.02 2.18-1.79 1.83-1.83 1.83 1.83 1.25 4.58 0 0 .77-.92 2.05 0 1.28.92-2.28 5.89-2.28 5.89s-2.55 2.71-4.35-5.89Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.04 124.21 47.03 92.26M63.59 100.54l-16.56-21.3",
    stroke: "#4C6EF5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryRightImage);
export default __webpack_public_path__ + "static/media/historyRightImage.4823383ac4fdcf4ba6fef202f8d74ded.svg";
export { ForwardRef as ReactComponent };